import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PendingApprovalCard = ({ approval, onApprove, onReject, onViewDetails }) => {
  const getTypeIcon = () => {
    switch (approval?.type) {
      case 'candidate':
        return 'UserCheck';
      case 'employer':
        return 'Building2';
      case 'reveal':
        return 'Shield';
      default:
        return 'AlertCircle';
    }
  };

  const getTypeBadge = () => {
    const badges = {
      candidate: 'bg-primary/10 text-primary',
      employer: 'bg-accent/10 text-accent',
      reveal: 'bg-warning/10 text-warning'
    };
    return badges?.[approval?.type] || 'bg-muted text-muted-foreground';
  };

  const getPriorityBadge = () => {
    const badges = {
      high: 'bg-error/10 text-error',
      medium: 'bg-warning/10 text-warning',
      low: 'bg-success/10 text-success'
    };
    return badges?.[approval?.priority] || 'bg-muted text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 elevation-sm border border-border">
      <div className="flex items-start gap-3 md:gap-4 mb-4">
        {approval?.avatar && (
          <Image 
            src={approval?.avatar} 
            alt={approval?.avatarAlt}
            className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover flex-shrink-0"
          />
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h4 className="text-base md:text-lg font-semibold text-foreground line-clamp-1">
              {approval?.title}
            </h4>
            <div className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getPriorityBadge()}`}>
              {approval?.priority}
            </div>
          </div>
          <div className="flex items-center gap-2 mb-2">
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getTypeBadge()}`}>
              <Icon name={getTypeIcon()} size={12} className="inline mr-1" />
              {approval?.type}
            </span>
            <span className="text-xs text-muted-foreground">{approval?.submittedDate}</span>
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
            {approval?.description}
          </p>
          {approval?.metadata && (
            <div className="flex flex-wrap gap-2 mb-3">
              {approval?.metadata?.map((item, index) => (
                <span key={index} className="text-xs bg-muted px-2 py-1 rounded-lg">
                  {item}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          iconName="FileText" 
          iconPosition="left"
          onClick={() => onViewDetails(approval)}
          className="flex-1"
        >
          View Details
        </Button>
        <Button 
          variant="success" 
          size="sm" 
          iconName="Check" 
          iconPosition="left"
          onClick={() => onApprove(approval)}
          className="flex-1"
        >
          Approve
        </Button>
        <Button 
          variant="destructive" 
          size="sm" 
          iconName="X" 
          iconPosition="left"
          onClick={() => onReject(approval)}
          className="flex-1"
        >
          Reject
        </Button>
      </div>
    </div>
  );
};

export default PendingApprovalCard;